// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3RmCK","alertIcon":"ConfirmModal_alertIcon__2MbCU"};